"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_exports = {};
__export(index_exports, {
  PrismaInstrumentation: () => import_chunk_LJOPUOKJ.PrismaInstrumentation,
  registerInstrumentations: () => import_instrumentation.registerInstrumentations
});
module.exports = __toCommonJS(index_exports);
var import_chunk_LJOPUOKJ = require("./chunk-LJOPUOKJ.js");
var import_chunk_TUF6OX4N = require("./chunk-TUF6OX4N.js");
var import_chunk_4TJH3LBI = require("./chunk-4TJH3LBI.js");
var import_chunk_FTA5RKYX = require("./chunk-FTA5RKYX.js");
var import_instrumentation = require("@opentelemetry/instrumentation");
